FairplayerImageVue(:url='url' :fallback-image='FairplayerFallbackImageUi.EXCLUSIVE' @load='onLoad')
